/**
 * FrSetup.tsx — v0.4.9.4.6 (placeholder)
 *
 * Face Recognition training surface. Placeholder for now — the actual
 * training UI ships in a later round. The placeholder shows:
 *   - what the feature will do
 *   - the planned data flow (model version, retraining trigger, etc.)
 *   - the open-source starting points we'd consider
 *
 * When the real component lands, this file becomes the parent that owns
 * the embedding viewer, the training trigger, and the metrics dashboard.
 * The route stays the same; only the body changes.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Construction, Camera, Database, Brain, FileSearch } from 'lucide-react';

export default function FrSetup() {
  const { t } = useTranslation();
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50/30 p-6 space-y-4">
      <div className="flex items-center gap-2">
        <Construction className="w-5 h-5 text-amber-700" />
        <h2 className="text-lg font-semibold text-amber-900">
          {t('aiTraining.comingSoonTitle')}
        </h2>
      </div>

      <p className="text-sm text-gray-900/80">
        {t('aiTraining.fr.description')}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
        <Card
          Icon={Database}
          title={t('aiTraining.fr.cards.dataset')}
          body={t('aiTraining.fr.cards.datasetBody')}
        />
        <Card
          Icon={Brain}
          title={t('aiTraining.fr.cards.training')}
          body={t('aiTraining.fr.cards.trainingBody')}
        />
        <Card
          Icon={FileSearch}
          title={t('aiTraining.fr.cards.audit')}
          body={t('aiTraining.fr.cards.auditBody')}
        />
      </div>

      <p className="text-xs text-gray-600">
        {t('aiTraining.comingSoonFootnote')}
      </p>
    </div>
  );
}

function Card({ Icon, title, body }: { Icon: React.ComponentType<any>; title: string; body: string }) {
  return (
    <div className="rounded border border-gray-300 bg-white p-4 space-y-2">
      <div className="flex items-center gap-2 text-gray-900">
        <Icon className="w-4 h-4" />
        <div className="font-medium text-sm">{title}</div>
      </div>
      <p className="text-xs text-gray-600">{body}</p>
    </div>
  );
}
